import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ComponentType } from '@angular/cdk/overlay';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '@core/services/user/user.service';
import { parseUserSettings } from '@shared/functions/parse-settings';
import { SOUND_STYLES } from '@shared/consts/sound-styles.const';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  public soundStyles = SOUND_STYLES;

  constructor(
    private snackBar: MatSnackBar,
    private toastr: ToastrService,
    private userService: UserService,
    private transloco: TranslocoService
  ) {}

  //ToDo: В будущем будет заменено на toastr.
  public open(message: string, type: string): void {
    const panelClass = type === 'success' ? 'green-snackbar' : 'red-snackbar';
    this.snackBar.open(
      message,
      this.transloco.translate('common.buttons.close'),
      {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        duration: 5000,
        panelClass: [panelClass],
      }
    );
  }

  public openFromComponent(
    component: ComponentType<unknown>,
    message: string,
    title: string,
    payload: any
  ): void {
    this.determineSoundToPlay(payload.text);
    this.toastr.show(message, title, {
      toastComponent: component,
      payload: payload,
      timeOut: 5000,
      disableTimeOut: 'extendedTimeOut',
      tapToDismiss: false,
    });
  }

  private determineSoundToPlay(key: string): void {
    const settings = this.userService.userInfo$.value!.settings;
    const globalSoundStyle = parseUserSettings(settings, 'notification.sounds');
    if (globalSoundStyle === 'off') {
      return;
    }
    const soundStyle = parseUserSettings(
      settings,
      'notification.' + key + '.sound.style'
    );
    if (soundStyle !== 'off') {
      const sound = this.soundStyles.find(
        (style) => style.value === soundStyle
      );
      if (sound?.src) {
        let audio: HTMLAudioElement = new Audio(sound.src);
        audio.play();
      }
    }
  }
}
